import api from './api';

export interface FileType {
  id: number;
  name: string;
  owner: 'PATIENT' | 'MEETING';
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface FileTypeCreate {
  name: string;
  owner: 'PATIENT' | 'MEETING';
}

export interface FileTypeUpdate {
  name?: string;
  owner?: 'PATIENT' | 'MEETING';
}

const fileTypeService = {
  getFileTypes: async (tenantId: number, owner?: 'PATIENT' | 'MEETING'): Promise<FileType[]> => {
    const params: any = { tenant_id: tenantId };
    if (owner) {
      params.owner = owner;
    }
    const response = await api.get('/file-types/', { params });
    return response.data;
  },

  // Get PATIENT file types - matches endpoint: GET /file-types/?owner=PATIENT
  getPatientFileTypes: async (): Promise<FileType[]> => {
    const params = { owner: 'PATIENT' };
    const response = await api.get('/file-types/', { params });  // With trailing slash to avoid 307 redirect
    return response.data;
  },

  getFileType: async (fileTypeId: number): Promise<FileType> => {
    const response = await api.get(`/file-types/${fileTypeId}`);
    return response.data;
  },

  createFileType: async (tenantId: number, data: FileTypeCreate): Promise<FileType> => {
    const response = await api.post(`/file-types/?tenant_id=${tenantId}`, data);
    return response.data;
  },

  updateFileType: async (fileTypeId: number, data: FileTypeUpdate): Promise<FileType> => {
    const response = await api.put(`/file-types/${fileTypeId}`, data);
    return response.data;
  },

  deleteFileType: async (fileTypeId: number): Promise<void> => {
    await api.delete(`/file-types/${fileTypeId}`);
  },
};

export default fileTypeService;
